<template>
  <div class="molded-seat-step-three">

    <div v-if="form.idc_cover">
      <v-layout>
        <v-switch v-model="form.idc_cover" hide-details label="Housses :" class="title mt-0"
          @change="clearCoverFields" />
        <v-radio-group v-model="form.cover_type" class="mt-2 ml-8" hide-details row :disabled="!form.idc_cover">
          <v-radio class="mt-0" label="Pression" value="PRESSURE" />
          <v-radio class="mt-0" label="Crochet" value="HOOK" />
        </v-radio-group>
      </v-layout>

      <v-radio-group v-model="form.cover_color_type" class="mt-2" hide-details row :disabled="!form.idc_cover">
        <v-radio label="Housses Stretch - Oxygene" value="STRETCH" style="font-size: 12px" />
        <v-radio v-if="form.type == 'RIGID'" label="Housses Vagues" value="WAVE" style="font-size: 12px" />
        <v-radio v-if="form.type == 'RIGID'" label="Housses Alcantara" value="ALCANTARA" style="font-size: 12px" />
        <v-radio v-if="form.type == 'RIGID'" label="Housses 3D" value="3D" style="font-size: 12px" />
      </v-radio-group>

      <div class="cadre mt-3 mb-15">
        <h3 class="mb-0">
          Zone Option
        </h3>

        <v-layout v-if="form.cover_color_type === 'ALCANTARA'" class="color-select">
          <v-select v-model="form.alcantara_id" :items="alcantaraColors" item-text="label" item-value="id"
            class="mb-3 mt-2" hide-details label="Couleur" filled clearable :disabled="!form.idc_cover" />
          <template v-if="previewAlcantaraColor">
            <v-flex v-if="previewAlcantaraColor.texture == 'TEXTURE'" class="preview" style="width: 35px; height: 35px">
              <img :src="previewAlcantaraColor.image" style="width: 100%; height:100%">
            </v-flex>
            <v-flex v-else-if="previewAlcantaraColor.texture == 'COLOR'" class="preview" :style="{
              'background-color': '#' + previewAlcantaraColor.rgb_code
            }" />
          </template>
        </v-layout>

        <v-layout v-if="form.cover_color_type === '3D'" class="color-select">
          <v-select v-model="form.three_d_id" :items="threeDColors" item-text="label" item-value="id" class="mb-3 mt-2"
            hide-details label="Couleur" filled clearable :disabled="!form.idc_cover" />
          <template v-if="preview3DColor">
            <v-flex v-if="preview3DColor.texture == 'TEXTURE'" class="preview" style="width: 35px; height: 35px">
              <img :src="preview3DColor.image" style="width: 100%; height:100%">
            </v-flex>
            <v-flex v-else-if="preview3DColor.texture == 'COLOR'" class="preview"
              :style="{ 'background-color': '#' + preview3DColor.rgb_code }" />
          </template>
        </v-layout>

        <div v-if="form.cover_color_type == 'WAVE'" class="prev-table">
          <v-switch class="mt-0" hide-details label="Prévisualisation" :disabled="!form.idc_cover" />
          <v-simple-table class="mb-3">
            <thead>
              <tr>
                <th class="text-center" />
                <th class="text-center">
                  HOUSE 1
                </th>
                <th class="text-center">
                  HOUSE 2
                </th>
                <th class="text-center">
                  HOUSE 3
                </th>
                <th class="text-center">
                  HOUSE 4
                </th>
                <th class="text-center">
                  HS1
                </th>
                <th class="text-center">
                  HS2
                </th>
                <th class="text-center">
                  HS3
                </th>
                <th class="text-center">
                  HS4
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>INTER</th>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_cover_id1" :items="stretchColors" item-text="label"
                      item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_cover_id2" :items="stretchColors" item-text="label"
                      item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-select v-model="form.wave_intern_cover_id3" :items="stretchColors" item-text="label"
                    item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-select v-model="form.wave_intern_cover_id4" :items="stretchColors" item-text="label"
                    item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_hs_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_hs_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_hs_id3" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_hs_id4" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
              </tr>

              <tr>
                <th>EXTER</th>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_cover_id1" :items="stretchColors" item-text="label"
                      item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_cover_id2" :items="stretchColors" item-text="label"
                      item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-select v-model="form.wave_extern_cover_id3" :items="stretchColors" item-text="label"
                    item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-select v-model="form.wave_extern_cover_id4" :items="stretchColors" item-text="label"
                    item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_hs_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_hs_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_hs_id3" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_hs_id4" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <div v-if="
          form.cover_color_type == 'STRETCH' || form.cover_color_type == null
        " class="prev-table">
          <v-switch class="mt-0" hide-details label="Prévisualisation" :disabled="!form.idc_cover" />
          <v-simple-table class="mb-3">
            <thead>
              <tr>
                <th class="text-center" />
                <th class="text-center">
                  HOUSE 1
                </th>
                <th class="text-center">
                  HOUSE 2
                </th>
                <th class="text-center">
                  HOUSE 3
                </th>
                <th class="text-center">
                  HOUSE 4
                </th>
                <th class="text-center">
                  HS1
                </th>
                <th class="text-center">
                  HS2
                </th>
                <th class="text-center">
                  HS3
                </th>
                <th class="text-center">
                  HS4
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>INTER</th>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_cover_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_cover_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-select v-model="form.intern_cover_id3" :items="stretchColors" item-text="label" item-value="id"
                    label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-select v-model="form.intern_cover_id4" :items="stretchColors" item-text="label" item-value="id"
                    label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_hs_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_hs_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_hs_id3" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_hs_id4" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
              </tr>

              <tr>
                <th>EXTER</th>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_cover_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_cover_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-select v-model="form.extern_cover_id3" :items="stretchColors" item-text="label" item-value="id"
                    label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-select v-model="form.extern_cover_id4" :items="stretchColors" item-text="label" item-value="id"
                    label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_hs_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_hs_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_hs_id3" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_hs_id4" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
    </div>

    <HousseComplexe :form="form" />

    <v-layout class="py-2 mt-4">
      <p class="title">Fixations: </p>
    </v-layout>
    <!-- Fixation -->
    <v-simple-table class="mb-3">
      <thead>
        <tr>
          <th class="text-center">
            <h4>Fixation :</h4>
          </th>
          <th class="text-center">
            Position
          </th>
          <th class="text-center">
            Sangle taille (mm)
          </th>
          <th class="text-center">
            Sangle matière
          </th>
          <th class="text-center">
            Velcro
          </th>
          <th class="text-center">
            Clip
          </th>
          <th class="text-center">
            Coussin
          </th>
          <th class="text-center">
            Atelier (mm)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Epaulière</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.shoulder_pad_position" :items="dropdowns.shoulder_pad_position" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.shoulder_pad_size_trap" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Epaulière) Sangle Taille') }" data-vv-name="(Epaulière) Sangle Taille"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.shoulder_pad_strap_matter" :items="dropdowns.shoulder_pad_strap_matter"
              item-text="label" item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-select v-model="form.shoulder_pad_velcro" :items="dropdowns.shoulder_pad_velcro" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.shoulder_pad_clip" :items="dropdowns.shoulder_pad_clip" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.shoulder_pad_cushion" :items="dropdowns.shoulder_pad_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.shoulder_pad_workshop" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Epaulière) Atelier') }" data-vv-name="(Epaulière) Atelier" type="number"
              hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Thorax</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.thorax_position" :items="dropdowns.thorax_position" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.thorax_size_trap" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Thorax) Sangle Taille') }" data-vv-name="(Thorax) Sangle Taille"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.thorax_strap_matter" :items="dropdowns.thorax_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-select v-model="form.thorax_velcro" :items="dropdowns.thorax_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.thorax_clip" :items="dropdowns.thorax_clip" item-text="label" item-value="value"
                label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.thorax_cushion" :items="dropdowns.thorax_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.thorax_workshop" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Thorax) Atelier') }" data-vv-name="(Thorax) Atelier" type="number"
              hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Plastron</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.chest_position" :items="dropdowns.chest_position" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.chest_size_trap" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Plastron) Sangle Taille') }" data-vv-name="(Plastron) Sangle Taille"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.chest_strap_matter" :items="dropdowns.chest_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-select v-model="form.chest_velcro" :items="dropdowns.chest_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.chest_clip" :items="dropdowns.chest_clip" item-text="label" item-value="value"
                label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.chest_cushion" :items="dropdowns.chest_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.chest_workshop" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Plastron) Atelier') }" data-vv-name="(Plastron) Atelier" type="number"
              hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Bassin</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.pelvis_position" :items="dropdowns.pelvis_position" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.pelvis_size_trap" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Bassin) Sangle Taille') }" data-vv-name="(Bassin) Sangle Taille"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.pelvis_strap_matter" :items="dropdowns.pelvis_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-select v-model="form.pelvis_velcro" :items="dropdowns.pelvis_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.pelvis_clip" :items="dropdowns.pelvis_clip" item-text="label" item-value="value"
                label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.pelvis_cushion" :items="dropdowns.pelvis_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.pelvis_workshop" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Bassin) Atelier') }" data-vv-name="(Bassin) Atelier" type="number"
              hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Femorale</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.femoral_position" :items="dropdowns.femoral_position" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.femoral_size_trap" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Femorale) Sangle Taille') }" data-vv-name="(Femorale) Sangle Taille"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.femoral_strap_matter" :items="dropdowns.femoral_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-select v-model="form.femoral_velcro" :items="dropdowns.femoral_velcro" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.femoral_clip" :items="dropdowns.femoral_clip" item-text="label" item-value="value"
                label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.femoral_cushion" :items="dropdowns.femoral_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.femoral_workshop" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Femorale) Atelier') }" data-vv-name="(Femorale) Atelier" type="number"
              hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Tibiale</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.tibial_position" :items="dropdowns.tibial_position" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.tibial_size_trap" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Tibiale) Sangle Taille') }" data-vv-name="(Tibiale) Sangle Taille"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.tibial_strap_matter" :items="dropdowns.tibial_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-select v-model="form.tibial_velcro" :items="dropdowns.tibial_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.tibial_clip" :items="dropdowns.tibial_clip" item-text="label" item-value="value"
                label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.tibial_cushion" :items="dropdowns.tibial_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.tibial_workshop" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Tibiale) Atelier') }" data-vv-name="(Tibiale) Atelier" type="number"
              hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Pied</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.foot_position" :items="dropdowns.foot_position" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.foot_size_trap" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Pied) Sangle Taille') }" data-vv-name="(Pied) Sangle Taille" type="number"
              hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.foot_strap_matter" :items="dropdowns.foot_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-select v-model="form.foot_velcro" :items="dropdowns.foot_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.foot_clip" :items="dropdowns.foot_clip" item-text="label" item-value="value" label
                outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.foot_cushion" :items="dropdowns.foot_cushion" item-text="label" item-value="value"
                label outlined clearable hide-details />
            </v-layout>
          </td>

          <td>
            <v-text-field v-model="form.foot_workshop" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Pied) Atelier') }" data-vv-name="(Pied) Atelier" type="number" hide-details
              outlined />
          </td>
        </tr>
        <tr>
          <th>Poignet</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.wrist_position" :items="dropdowns.wrist_position" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.wrist_size_trap" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Poignet) Sangle Taille') }" data-vv-name="(Poignet) Sangle Taille"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.wrist_strap_matter" :items="dropdowns.wrist_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details />
          </td>
          <td>
            <v-select v-model="form.wrist_velcro" :items="dropdowns.wrist_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.wrist_clip" :items="dropdowns.wrist_clip" item-text="label" item-value="value"
                label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.wrist_cushion" :items="dropdowns.wrist_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.wrist_workshop" v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Poignet) Atelier') }" data-vv-name="(Poignet) Atelier" type="number"
              hide-details outlined />
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-textarea v-model="form.mounting_comment" filled name="Ajouter un commentaire :"
      label="Ajouter un commentaire :" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HousseComplexe from "../../modules/HousseComplexe.vue";

export default {
  name: "MoldedSeatStepThree",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  components: {
    HousseComplexe,
  },

  computed: {
    ...mapGetters({
      stretchColors: "colors/getSTRETCHType",
      alcantaraColors: "colors/getALCANTARAType",
      threeDColors: "colors/get3DType",

      dropdowns: "dropdowns/getMoldedSeatOptions",
    }),

    previewAlcantaraColor() {
      return this.alcantaraColors.find(
        (color) => color.id == this.form.alcantara_id
      );
    },

    preview3DColor() {
      return this.threeDColors.find(
        (color) => color.id == this.form.three_d_id
      );
    },

    previewWavesColor() {
      return this.stretchColors.find((color) => color.id == this.form.waves_id);
    },
  },

  created() {
    this.$validator = this.parentValidator;
  },

  methods: {
    ...mapActions({
      getDropdownsByProduct: "dropdowns/getLocalDropdownsByProduct",
      getColors: "colors/getAllColors",
    }),

    // Clear cover fields
    clearCoverFields(all = true) {
      if (all) {
        this.form.cover_color_type = null;
      }

      this.form.cover_type = null;
      this.form.intern_cover_id1 = null;
      this.form.intern_cover_id2 = null;
      this.form.intern_cover_id3 = null;
      this.form.intern_cover_id4 = null;
      this.form.intern_hs_id1 = null;
      this.form.intern_hs_id2 = null;
      this.form.intern_hs_id3 = null;
      this.form.intern_hs_id4 = null;
      this.form.extern_cover_id1 = null;
      this.form.extern_cover_id2 = null;
      this.form.extern_cover_id3 = null;
      this.form.extern_cover_id4 = null;
      this.form.extern_hs_id1 = null;
      this.form.extern_hs_id2 = null;
      this.form.extern_hs_id3 = null;
      this.form.extern_hs_id4 = null;
      this.form.wave_intern_cover_id1 = null;
      this.form.wave_intern_cover_id2 = null;
      this.form.wave_intern_cover_id3 = null;
      this.form.wave_intern_cover_id4 = null;
      this.form.wave_intern_hs_id1 = null;
      this.form.wave_intern_hs_id2 = null;
      this.form.wave_intern_hs_id3 = null;
      this.form.wave_intern_hs_id4 = null;
      this.form.wave_extern_cover_id1 = null;
      this.form.wave_extern_cover_id2 = null;
      this.form.wave_extern_cover_id3 = null;
      this.form.wave_extern_cover_id4 = null;
      this.form.wave_extern_hs_id1 = null;
      this.form.wave_extern_hs_id2 = null;
      this.form.wave_extern_hs_id3 = null;
      this.form.wave_extern_hs_id4 = null;
      this.form.alcantara_id = null;
      this.form.three_d_id = null;
    },
  },
};
</script>

<style>
.cadre {
  background-color: rgb(235, 245, 245);
  height: 200px;
  padding: 10px;
  border-radius: 4px;
}
</style>
